export default "__VITE_ASSET__CQTO0F4H__"